<template>
    <div>
        <!-- Space -->
        <div class="space-web visible-lg visible-md"></div>
        <div class="space-mobil visible-xs visible-sm"></div>

        <!-- Buscador Movil -->
        <!-- <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="busqueda-contenido2 visible-sm visible-xs">
                        <form role="form" @submit.prevent="generalSearch" method="get" >
                            <ul class="list-inline">
                                <li style="width: 77%;"><input v-model="simpleSearchInput" autocomplete="off" class="form-control"  @keyup="getList"  placeholder="Buscar en Who's Who..."></li>
                                <li style="width: 10%;"><a  @click.prevent="generalSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                            </ul>
                            <div class="autocomplete" v-show="isOpen" >
                                <ul class="autocomplete-results">
                                    <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                        {{ result.nameRecord }}
                                    </li>
                                </ul>
                            </div>
                            <div class="radio-ww animated slideInRight visible-sm visible-xs">
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div> -->

        <!-- Banner Horizontal -->
        <div class="banner visible-lg visible-md animated slideInDown">
            <div class="container" v-if="contactCompanies[0]">
                <div id="sas_31458" >
                    <script2 v-if="getBanner(contactCompanies[0].banners, 'banner-top').length">
                        {{ getBanner(contactCompanies[0].banners, 'banner-top')[0] }}
                    </script2>
                </div>
            </div>
        </div>

        <!-- Contenido -->
        <div class="contenido-resultados" >
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <!-- Ficha Persona -->
                        <div class="contacto-persona animated slideInLeft">
                            <div class="row">
                                <div class="col-md-4" align="center">
                                    <div class="imagen-persona-contacto">
                                        <a href="">
                                            <div class="feat-image" v-if="contact.Images && contact.Images !== null" :style="{ 'background-image':  'url('+ getImageUrl(contact.Images) +')' }"></div>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-8 info-resultado">
                                    <router-link :to="'/contacto/'+contact.permalink_contacto" >
                                        <h1 v-if="(typeof contact.LastName !== 'undefined' )"  v-html="contact.FirstName+' '+contact.LastName" ></h1>
                                    </router-link>
                                    <h2 v-html="contact.Title" v-if="(typeof contact.Title !== 'undefined' )"  ></h2>

                                    <router-link :to="'/empresa/'+contact.permalink_empresa" >
                                        <h3  v-html="contact.CompanyName" ></h3>
                                    </router-link>
                                    <p v-html="contact.NombreCategory" v-if="(typeof contact.NombreActivity !== 'undefined' )" ></p>
                                    <div class="icons-contacto">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Noticias , English y Videos-->
                        <app-content v-if="contact && contact.IdContactFM" :contact="contact" :key="contact.IdContactFM"></app-content>
                    </div>
                    <div class="col-md-4 animated slideInRight">
                        <div class="banner" v-if="contactCompanies[0]">
                            <div id="sas_31459">
                                <script2 v-if="getBanner(contactCompanies[0].banners, 'banner-lateral').length">
                                    {{ getBanner(contactCompanies[0].banners, 'banner-lateral')[0] }}
                                </script2>
                            </div>
                        </div>
                        <!-- Empresas -->
                        <div class="empresa"  v-if="contactCompanies[0] && (typeof contactCompanies !== 'undefined' ) ">
                            <h1>EMPRESA</h1>
                            <hr>
                            <div class="scroll-empresa">
                                <div class="lista-empresa">
                                    <router-link :to="'/empresa/'+contactCompanies[0].slug" >
                                        <h2  v-html="contactCompanies[0].title" ></h2>
                                    </router-link>
                                    <p v-html="contactCompanies[0].location.address" ></p>
                                    <div v-if="contactCompanies[0].contact_info && Array.isArray(contactCompanies[0].contact_info)">
                                        <div>
                                            <p v-if="getContactValues(contactCompanies[0].contact_info, 'email').length">
                                                <strong>
                                                    {{ getContactValues(contactCompanies[0].contact_info, 'email')[0] }}
                                                </strong>
                                            </p>

                                            <p v-if="getContactValues(contactCompanies[0].contact_info, 'telefono').length">
                                                <strong>Tel:</strong>
                                                {{ getContactValues(contactCompanies[0].contact_info, 'telefono')[0] }}
                                            </p>

                                            <p v-if="getContactValues(contactCompanies[0].contact_info, 'fax').length">
                                                <strong>Fax:</strong>
                                                {{ getContactValues(contactCompanies[0].contact_info, 'fax')[0] }}
                                            </p>

                                            <div v-if="getContactValues(contactCompanies[0].contact_info, 'url').length">
                                                <a
                                                    class="urlSite"
                                                    :href="getContactValues(contactCompanies[0].contact_info, 'url')[0].startsWith('http')
                                                        ? getContactValues(contactCompanies[0].contact_info, 'url')[0]
                                                        : 'http://' + getContactValues(contactCompanies[0].contact_info, 'url')[0]"
                                                    target="_blank"
                                                >
                                                    <strong>Visitar página web</strong>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                            </div>
                            <br>
                        </div>

                        <!-- Ejecutivos -->
                        <div class="ejecutivo" v-if="contacts && Array.isArray(contacts) && contacts.length > 0">
                            <h1>EJECUTIVOS</h1>
                            <hr>
                            <div class="scroll-empresa">
                                <template v-for="tmp in contacts" v-if="tmp">
                                    <div class="lista-ejecutivos">
                                        <router-link :to="'/contacto/'+tmp.slug" @click.native="onEjecutivoClick(tmp.slug)">
                                            <h2 v-html="tmp.title" style="text-align: left !important"></h2>
                                        </router-link>
                                        <p v-html="tmp.company && tmp.company.position ? tmp.company.position : ''"></p>
                                    </div>
                                    <hr>
                                </template>
                            </div>
                        </div>

                        <!-- Adicionales -->
                        <div class="ejecutivo" v-if="additionalCompanies && Array.isArray(additionalCompanies) && additionalCompanies.length > 0">
                            <h1>ADICIONALES</h1>
                            <hr>
                            <div class="scroll-empresa">
                                <template v-for="tmp in additionalCompanies" v-if="tmp">
                                    <div class="lista-ejecutivos">
                                        <router-link :to="'/empresa/'+tmp.slug">
                                            <h2 v-html="tmp.name" style="text-align: left !important"></h2>
                                        </router-link>
                                        <p v-html="tmp.position ? tmp.position : ''"></p>
                                    </div>
                                    <hr>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Contacto -->
        <div class="modal  fade" id="ModalContacto" role="dialog">
            <div class="modal-dialog contacto">
                <div class="modal-content">
                    <div class="modal-header" align="center">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">Contactar</h4>
                        <p>Envia un mensaje personalizado al contacto</p>
                    </div>
                    <div class="modal-body" align="center">
                        <div align="left">
                            <div class="row">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-10">
                                <h5><strong>Destinatario:</strong> {{  contact.FirstName+' '+contact.LastName }}</h5>
                            </div>
                            <div class="col-sm-1"></div>
                            </div>
                        </div>
                        <hr>
                        <form class="form-horizontal" @submit.prevent="sendEmailContactWW"  method="post" >
                            <div class="form-group">
                                <div class="col-sm-1"></div>
                                <div class="col-sm-10">
                                    <input  type="text" class="form-control " :class="contactoEmailErrorMsg ? 'error_form' : ''" v-model="contactoEmail"  placeholder="Remitente (email)" />
                                </div>
                                <div class="col-sm-1"></div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-1"></div>
                                <div class="col-sm-10">
                                    <input  type="text" class="form-control" :class="contactoNameErrorMsg ? 'error_form' : ''" v-model="contactoTitle"  placeholder="Título" />
                                </div>
                                <div class="col-sm-1"></div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-1"></div>
                                <div class="col-sm-10">
                                    <textarea class="form-control" :class="contactMsgErrorMsg ? 'error_form' : ''"   rows="6" id="comment" v-model="contactMsg"  placeholder="Escribe tu comentario..." ></textarea>
                                </div>
                                <div class="col-sm-1"></div>
                            </div>

                            <div class="form-group" v-if="emailSent">
                                <div class="alert alert-success col-sm-12" role="alert">
                                    Email Enviado!
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-1"></div>
                                <div class="col-sm-10" align="center">
                                    <button @click.prevent="sendEmailContactWW" type="button" class="btn " >ENVIAR MENSAJE</button>
                                </div>
                                <div class="col-sm-1"></div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer" align="center">
                        <h6>Visita PRODU.COM</h6>
                        <div class="row">
                            <i class="fa fa-facebook"></i>
                            <i class="fa fa-twitter"></i>
                            <i class="fa fa-google"></i>
                            <i class="fa fa-linkedin"></i>
                            <i class="fa fa-youtube"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Compartir -->
        <div class="modal  fade" id="ModalCompartir" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header" align="center">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">Compartir</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="12">
                                <div class="redes-modal-compartir">
                                    <a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://www.facebook.com/sharer/sharer.php?u=http://who.produ.com/contacto/'+contact.IdContactFM"  data-dismiss="modal" ><h5><i class="fa fa-facebook"></i>Facebook</h5></a>
                                </div>
                                <hr>
                                <div class="redes-modal-compartir">
                                <a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://twitter.com/intent/tweet?status='+contact.FirstName+' '+contact.LastName+'http://who.produ.com/contacto/'+contact.IdContactFM+'&title='+contact.FirstName+' '+contact.LastName"  class="twitter"  data-dismiss="modal" ><h5><i class="fa fa-twitter"></i>Twitter</h5></a>
                                </div>
                                <hr>
                                <div class="redes-modal-compartir">
                                    <a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'https://api.whatsapp.com/send?text=' +contact.FirstName + ' ' + contact.LastName + ' ' + 'http://who.produ.com/contacto/'+contact.IdContactFM"  class="whatsapp show-for-small-only icon-whatsapp"  data-dismiss="modal"><h5><i class="fa fa-whatsapp" target="_blank"></i>Whatsapp</h5></a>
                                </div>
                                <hr>
                                <div class="redes-modal-compartir lastItem" >
                                    <a href="" data-toggle="modal" data-target="#ModalContacto"  data-dismiss="modal" ><h5><i class="fa fa-google"></i>Gmail</h5></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Cerrar Sesión -->
        <div class="modal  fade" id="ModalCerrarSesion" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header" align="center">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">Cerrar Sesión</h4>
                    </div>
                    <div class="modal-body" align="center">
                        <p>¿Seguro que deseas Cerrar Sesión?</p>
                        <div class="row">
                            <div class="col-sm-2"></div>
                            <div class="col-sm-8">
                                <button class="btn_aceptar close"  data-dismiss="modal">Aceptar</button>
                                <button class="btn_cancelar close"  data-dismiss="modal">Cancelar</button>
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                    </div>
                    <div class="modal-footer" align="center">
                        <h6>Visita PRODU.COM</h6>
                        <div class="row">
                            <i class="fa fa-facebook"></i>
                            <i class="fa fa-twitter"></i>
                            <i class="fa fa-google"></i>
                            <i class="fa fa-linkedin"></i>
                            <i class="fa fa-youtube"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';

    import axios from 'axios';

    import Content from './contact/Content.vue';
    import '../assets/css/contacto.css';

    const flowBridgeAPIBase = process.env.FLOWBRIDGE_URL;

    export default {
        name: 'Contacto',
        components: {
            'app-content': Content,
        },
        data() {
            return {
                resultSearch: [],
                AdvanceSearchInput: '',
                simpleSearchInput: '',
                countries: [],
                categories: [],
                activities: [],
                categoryIn: 0,
                contactoIn: '',
                empresaIn: '',
                countryIn: 0,
                activityIn: 0,
                contactID: 0,
                contact: [],
                contactCompanies: [],
                contacts: [],
                additionalCompanies: [],
                isMobile: false,
                contactoName: '',
                contactoEmail: '',
                contactMsg: '',
                contactoTitle: '',
                contactoNameErrorMsg: false,
                contactoEmailErrorMsg: false,
                contactMsgErrorMsg: false,
                contactoTitleErrorMsg: false,
                emailSent: false,
                metaTitle: '',
                metaDescr: '',
                metaUrl: '',
                metaImg: '',
                errors: [],
                selectedSearchIn: 'ww',
                isOpen: false,
                auxSearch: {},
                contactos: [],
                nombres: '',
                permalink: 0,
                defaultImage: require('@/assets/images/avatar2.png'),
                imageCache: {},
            };
        },
        metaInfo() {
            return {
                title: this.metaTitle,
                meta: [{ property: 'og:url', content: this.metaUrl }],
                meta: [{ property: 'og:type', content: 'website' }],
                meta: [{ name: 'author', content: 'PRODU' }],
                meta: [{ name: 'description', content: this.metaDescr }],
                meta: [{ name: 'copyright', content: 'PRODU' }],
                meta: [{ property: 'og:title', content: this.metaTitle }],
                meta: [{ property: 'og:image', content: this.metaImg }],
            };
        },
        created() {},
        methods: {
            moment: function() {
                return moment();
            },
            // Devuelve un array con los valores de un tipo de contacto dado
            getContactValues: function(contact_info, tipo) {
                if (!Array.isArray(contact_info)) return [];
                return contact_info
                    .filter(item => item.slug === tipo)
                    .map(item => item.value);
            },
            getBanner: function(banners, position) {
                if (!Array.isArray(banners)) return [];
                return banners
                    .filter(item => item.banner_location === position)
                    .map(item => item.banner_smart_ad_code);
            },
            getImageUrl: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '') {
                    return this.defaultImage;
                }

                // Si ya validamos esta URL, usar el resultado del cache
                if (this.imageCache.hasOwnProperty(imageUrl)) {
                    return this.imageCache[imageUrl];
                }

                // Por defecto retornar la URL original y validar en background
                this.validateImageInBackground(imageUrl);
                return imageUrl;
            },
            validateImageInBackground: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '' || this.imageCache.hasOwnProperty(imageUrl)) {
                    return;
                }

                const img = new Image();

                img.onload = () => {
                    this.$set(this.imageCache, imageUrl, imageUrl);
                };

                img.onerror = () => {
                    // Marcar como error en cache
                    this.$set(this.imageCache, imageUrl, this.defaultImage);

                    // Actualizar todos los items que usan esta imagen
                    this.updateItemsWithFailedImage(imageUrl);
                };

                img.src = imageUrl;
            },
            updateItemsWithFailedImage: function(failedUrl) {
                // Actualizar imágenes en noticias español
                this.contactNews.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });

                // Actualizar imágenes en noticias inglés
                this.contactNewsE.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });

                // Actualizar imágenes en videos
                this.contactVideosNew.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });
            },
            getContact: async function(contacID) {

                this.contactID = contacID;

                await axios.get(flowBridgeAPIBase + 'contacts/slug/'+this.contactID, {
                    params: {
                        fields: 'featured_image,company'
                    }
                }).then(response => {
                    const seletedContact = response.data.data;
                    const companyId = (seletedContact.company && seletedContact.company.primary && seletedContact.company.primary.id) ? seletedContact.company.primary.id : (seletedContact.company && seletedContact.company.id ? seletedContact.company.id : '');

                    // Obtener empresas adicionales
                    this.additionalCompanies = (seletedContact.company && seletedContact.company.additional) ? seletedContact.company.additional : [];

                    // Extraer sector_info de primary o company
                    const sectorInfo = (seletedContact.company && seletedContact.company.primary && seletedContact.company.primary.sector_info)
                        ? seletedContact.company.primary.sector_info
                        : (seletedContact.company && seletedContact.company.sector_info ? seletedContact.company.sector_info : null);

                    const categoryName = (sectorInfo && sectorInfo.principal && sectorInfo.principal.category_company)
                        ? sectorInfo.principal.category_company.name
                        : '';

                    const activityName = (sectorInfo && sectorInfo.principal && sectorInfo.principal.activity_category)
                        ? sectorInfo.principal.activity_category.name
                        : '';

                    axios.get(flowBridgeAPIBase + 'companies/' + companyId, {
                        params: {
                            fields: 'location,banners,contact_info,who'
                        }
                    }).then(companyResponse => {
                        this.contactCompanies = [companyResponse.data.data];
                        this.contacts = (companyResponse.data.data.who && companyResponse.data.data.who.organization_chart && companyResponse.data.data.who.organization_chart.contacts) || [];
                        this.metaUrl = 'http://who.produ.com/contacto/' + seletedContact.post_id;
                    });


                    this.contact = {
                        IdContactFM: seletedContact.post_id,
                        FirstName: seletedContact.name,
                        LastName: seletedContact.last_name,
                        Title: (seletedContact.company && seletedContact.company.primary && seletedContact.company.primary.position) ? seletedContact.company.primary.position : (seletedContact.company && seletedContact.company.position ? seletedContact.company.position : ''),
                        metaTitle: seletedContact.name + ' ' + seletedContact.last_name,
                        metaDescr: seletedContact.name + ' ' + seletedContact.last_name,
                        metaImg: seletedContact.featured_image.url,
                        permalink_contacto: seletedContact.slug,
                        Images: seletedContact.featured_image.url,
                        IdCompanyFM: (seletedContact.company && seletedContact.company.primary && seletedContact.company.primary.id) ? seletedContact.company.primary.id : (seletedContact.company && seletedContact.company.id ? seletedContact.company.id : ''),
                        CompanyName: (seletedContact.company && seletedContact.company.primary && seletedContact.company.primary.name) ? seletedContact.company.primary.name : (seletedContact.company && seletedContact.company.name ? seletedContact.company.name : ''),
                        permalink_empresa: (seletedContact.company && seletedContact.company.primary && seletedContact.company.primary.slug) ? seletedContact.company.primary.slug : (seletedContact.company && seletedContact.company.slug ? seletedContact.company.slug : ''),
                        NombreCategory: categoryName,
                        NombreActivity: activityName,
                    }

                    // Actualizar el título de la página
                    if (this.contact && this.contact.FirstName && this.contact.LastName) {
                        this.metaTitle = this.contact.FirstName + ' ' + this.contact.LastName;
                    } else {
                        this.metaTitle = 'Who is Who';
                    }

                    this.$nextTick(function() {});
                });
            },
            getActivity: async function() {
                if (this.categoryIn) {
                    await axios
                        .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                            token:
                                'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                            category: this.categoryIn,
                        })
                        .then(response => {
                            this.activities = response.data;

                            this.$nextTick(function() {});
                        });
                }
            },
            advanceSearch: async function(page) {
                this.currentPage = page;
                this.$router.push(
                    '/advancesearch/' +
                        this.contactoIn +
                        '_' +
                        this.empresaIn +
                        '_' +
                        this.countryIn +
                        '_' +
                        this.categoryIn +
                        '_' +
                        this.activityIn
                );
            },
            contactSearch: function(e) {
                if (this.simpleSearchInput) {
                    this.$router.push('/busqueda/' + this.simpleSearchInput);
                }
            },
            getDataClick: async function(newVal) {
                this.contactID = newVal;
                this.$route.params.contacto = this.contactID;
                this.getContact(newVal);
            },
            sendEmailContactWW: async function(e) {
                this.errors = [];
                this.contactoNameErrorMsg = false;
                this.contactMsgErrorMsg = false;
                this.contactoEmailErrorMsg = false;

                if (!this.contactoTitle) {
                    this.contactoNameErrorMsg = true;
                    this.errors.push('Titulo requerido.');
                }
                if (!this.contactMsg) {
                    this.contactMsgErrorMsg = true;
                    this.errors.push('Mensage requerido.');
                }

                if (!this.contactoEmail || !this.validEmail(this.contactoEmail)) {
                    this.contactoEmailErrorMsg = true;
                    this.errors.push('Valid Email required.');
                }

                if (this.contact && this.errors.length == 0) {
                    await axios
                        .post(resfulApi + 'sendEmailContactWW', {
                            token:
                                'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                            email: this.contactoEmail,
                            title: this.contactoTitle,
                            msg: this.contactMsg,
                            emailD: this.contact.Email,
                        })
                        .then(response => {
                            this.emailSent = parseInt(response.data) == 1;
                            this.$nextTick(function() {});
                        });
                }
            },
            simpleSearch: function(e) {
                if (this.simpleSearchInput && this.isActiveSearch()) {
                    this.nombres =
                        this.nombres == '' ? this.simpleSearchInput : this.nombres;
                    this.$router.push({
                        name: 'Search',
                        params: {
                            permalink: this.permalink,
                            tipo: this.selectedSearchIn,
                            search: this.simpleSearchInput,
                            nombres: this.nombres,
                        },
                    });
                }
            },
            generalSearch: function(e) {
                if (this.simpleSearchInput && this.isActiveSearch()) {
                    this.nombres = this.simpleSearchInput;
                    this.$router.push({
                        name: 'Search',
                        params: {
                            permalink: 0,
                            tipo: this.selectedSearchIn,
                            search: this.simpleSearchInput,
                            nombres: this.nombres,
                        },
                    });
                }
            },
            isActiveSearch() {
                return !this.selectedSearchIn || this.simpleSearchInput.length <= 0
                    ? false
                    : true;
            },
            getList: function() {
                this.simpleSearchInput.length > 3
                    ? this.getSearchWWFWS()
                    : (this.isOpen = false);
            },
            getSearchWWFWS: async function() {
                await axios
                    .post(resfulApi + 'getSearchWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        search: this.simpleSearchInput,
                        tipo: this.selectedSearchIn,
                    })
                    .then(response => {
                        this.contactos = response.data;
                        this.contactos.length > 0
                            ? (this.isOpen = true)
                            : (this.isOpen = false);
                    });
            },
            setResult: async function(result) {
                this.simpleSearchInput = result.nombres;
                this.permalink = result.permalink;
                this.nombres = result.nombres;
                this.isOpen = false;
                var typeSearch = this.redirectConsulta(
                    result.nameRecord,
                    result.GuiaOTT
                );
                this.$router.push('/' + typeSearch + '/' + result.permalink);
            },
            onEjecutivoClick(slug) {
                // Navega y fuerza recarga del contacto
                this.getContact(slug);
            },
        },
        beforeMount() {},
        mounted: function() {
            this.contactID = this.$route.params.contacto;

            this.isMobile = this.checkMobile();

            this.getContact(this.contactID);
            // this.getDataForm();
        },
        watch: {
            '$route.params.contacto'(newId, oldId) {
                this.contactID = newId;
                this.getContact(this.contactID);
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .filtro-negro a:hover {
        cursor: pointer;
    }

    a:hover {
        cursor: pointer;
    }

    .ficha {
        overflow: inherit !important;
    }

    .blog .ficha .blog-content h3 {
        line-height: 1.2 !important;
    }

    .contact-header {
        margin-top: 20px;
    }

    .contact-share-icons {
        text-align: right;
        padding-right: 20px;
    }

    .urlSite {
        color: #016e8f;
    }

    @media only screen and (max-width: 650px) {
        .blog-content h1,
        a,
        h4 {
            text-align: center !important;
        }

        .contact-share-icons {
            text-align: center;
            padding-right: 0px;
        }

        .contact-header {
            margin-top: -40px;
            padding-top: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Contacto.vue